<template>
    <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Geospatial Location</h5>

          <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
        </div>
        <div class="modal-body">
            <p class="lead">{{ thelocation }}</p>
            <input class="form-control input-lg" placeholder="Enter address or location info" v-model="blobRequest" />
            <button class="btn btn-lg btn-primary" @click="requestGeocode()">Look up location</button>
        </div>
    </div>    
</template>
        
<script>
import axios from 'axios';
export default {
    name: "Add new location",
    data() {
        return {
            thelocation: '',
            blobRequest: ''
        }
    },
    methods: {
        requestGeocode() {
        this.polylines = [];
        console.log('the request '+this.blobRequest);
        axios.get('/geocode',{ params: {addr: this.blobRequest} })
        .then(
                (response) => {
            console.log('geocode/address lookup response: '+JSON.stringify(response.data));
            this.thelocation = JSON.stringify(response.data);
        }).catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
        },
    },
    mounted() {
        console.log('Add location modal opened!');
    }     
}
</script>